import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, Injector, Input, OnChanges, OnDestroy, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as L from 'leaflet';
import 'leaflet.vectorgrid';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
import { Chartconstant } from 'src/app/utils/chart.constant';
import { MapService } from 'src/app/utils/map.service';
import { ProjConstants } from 'src/app/utils/proj.constant';
import 'src/assets/leaflet-geojson-tilelayer/TileLayer.GeoJSON.js';
import 'src/assets/leaflet-image-transform/L.ImageTransform.js';
import 'src/assets/leaflet-spin/leaflet.spin.js';
import 'src/assets/leaflet-spin/leaflet.spin.min.js';
import 'src/assets/leaflet-velocity-src/js/L.CanvasLayer.js';
import 'src/assets/leaflet-velocity-src/js/L.Control.Velocity.js';
import 'src/assets/leaflet-velocity-src/js/L.VelocityLayer.js';
import 'src/assets/leaflet-velocity-src/js/windy.js';
import 'src/assets/map-control/L.control.HtmlLegend.js';
import 'src/assets/map-control/L.Control.ZoomBars.js';
import { isNullOrUndefined, isUndefined } from 'util';
import { UtilsSharedModule } from '../utils/utils/utils.module';
import { FloodForecastUtilsService } from './../../side-bar/flood-forecast/flood-forecast-shared/floodForecastUtils.service';
import { FloodForecastMapService } from '../../side-bar/flood-forecast/flood-forecast-map.service';



@Component({
  selector: 'app-gis-map-flood-forecast',
  templateUrl: './gis-map-flood-forecast.component.html',
  styleUrls: ['./gis-map-flood-forecast.component.scss']
})
export class GisMapFloodForecastComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  @Input() mapData: any;
  @Input() component: any;
  @Input() index: any;
  @Input() windData: any;
  @Input() blocksArray: any;
  @Input() mapDataForAllTs: any;
  @Input() windDataForAllTs: any;
  @Input() heatMapURLlist: any;
  @Input() windDataURLlist: any;
  @Input() layerList: any;
  @Input() tableDataComponent: any;
  @Input() otherOptions: any;
  @Input() basinGeoJSONData: any;
  @Input() giscolorsdata: any;
  @Input() legenddata: any;
  @Input() hidebottombar: any;
  @Input() sourceSelected: any;

  map: any;
  flag = true;
  geoJsonData: any;
  playButtonDisable = true;
  indexForLeftPanel: any;
  citiesData: any;
  chartData: any = [];
  chartOptions: any;
  context: CanvasRenderingContext2D;
  tsArrayForPlay: any = [];
  tsLabelsArrayForPlay: any = [];
  direction: any;
  state = 'stop';
  popUpData: any = {};
  postData: any;
  bottomBarData: any;
  bottomBarColumns: any = [];
  velocityLayer;
  wmsLayerGroup;
  allLayerList: any = [];
  overlayLayerList: any = [];
  geojsonLayerList: any = [];
  wmsLayerList: any = [];
  wmsUrl: any;
  wmsLayer: any;
  value: any = 3;
  imageUrl: any;
  adminSelected: any;
  forecastLength: any;
  shortLongRange: any;
  imageBounds: any = [];
  playpause: boolean;
  startIndex = 1;
  imageLayer: any;
  showThrobber: any;
  bottomBarMenuSelectedIndex;
  styleObjforBottomBar = {};
  vectorTileLayer = {};
  urlParams: any = {};
  labelStrings = [];
  marker = null;
  noData = false;
  blocks: any;
  Linechart: any;
  millisInSixHours = ProjConstants.MILLIS_IN_6HOURS;
  showBottomBar: any;
  districtClicked: object;
  particleMultiplier: any = 0.0006;
  showThrobberbottomBar = false;
  abbrvMapping = ProjConstants.COMPONENT_ABBREVIATION_MAPPING;
  heatMapoptions = {
    opacity: 0.8,
    pane: 'heatMap',
    minZoom: 6,
    maxZoom: 15
  };
  layers: any = {
    overlaylayers: {},
    baselayers: {}
  };
  borderBottomBarStyle = {};
  // timestamp:;
  colorForBottomBar: any;
  nowForPlay: any;
  bottomBarDataWithStyle: any;
  bottomBarTableStyles: any = {};
  gradientColors: any = [];
  gradientStyles: any = {};
  heightHundred: any = {};
  gradient: any;
  blockLayer: any;
  customMarker = new L.icon({
    iconUrl: 'https://upload.wikimedia.org/wikipedia/commons/9/93/Map_marker_font_awesome.svg',
    iconSize: [35, 41],
    iconAnchor: [14, 41],
    popupAnchor: [15, -40]
  });
  yAxisMin: any;
  chartTableData: any;
  chartGradient: any;
  dateList: any;
  clickedLocationMarker: any;
  clickedLocationTooltip: any;
  bottomTableKeys: any = [];
  playWidth: any = 3;
  stateBoundary: any;
  basinBoundary: any;
  activeTimePeriod: any;
  districtClickedSubscription: any;
  adminBasinSubscription: any;
  forecastLengthSubscription: any;
  toggleSubscription: any;
  timeStampList: {};
  revalidateMapSubscription: any;
  selectedLocation: any;
  dataTabToggleVal = false;
  activeLayers: any = [];
  activeGroup: any;
  leftSideBarSubscription: any;
  apiData: any;
  type: string;
  apiParams: any;
  minMax: any;
  STATENAME: any;
  serviceMap: any;
  bottomBarComponent: any;
  legend: any;
  thresholdMap: object;
  initialCounter: number;
  style = {
    stroke: false,
    color: '#FF0000',
    fill: true,
    fillColor: '#FF0000',
    fillOpacity: 0.4,
    opacity: 0.4
  };
  componentType: string;
  hourCounter = '';
  blockNumber = 0;
  dateBlockNumMap = {};
  playPosition = 0;
  collapsebutton: any;
  activeSideMenu: any;
  polygons = [];
  bottombarClick: boolean;
  selectedComponent: string;
  meanMedian: string;
  showOption = false;
  selectedOption: any;

  view = 'Admin';

  subscriptions: Subscription[] = [];
  subscriptionCount = 0;
  regionSelected = 'southZone';
  baseLayers: any;
  layersList = {
    baseLayers: {}, overlayLayers: {}
  };
  metaData: any;
  metaDataobj: any={
    basin : '',
    hecHms : ''
  };
  basinTableDataForImpPoints: {};
  tableDataToDiplay: {};
  floodForecastWMSTileLayerConfig: any;
  stateUrlId: any;
  spinnerSubscription: any;
  regionSelectedSubscription: any;
  htmlLegendObjects: any = [];
  openDataTabSubscription: any;
  floodForecastFilterSubscription: Subscription;
  floodForecastPointGeoJson: any;
  navigationSubscription: Subscription;
  initSubScriptions: any = [true, true, true, true, true];
  throbbers: any = [false, false, false, false, false];
  htmlLegend: any;
  floodForecastGeoJSONLayersConfig: any;
  deviceInfo: any = {};
  screenWidth: number;
  removeCatchmentSubscription: any;
  isActive: boolean;
  applicationName : string;
  componentName : string;

  constructor(public mapService: MapService, private route: ActivatedRoute,
    public chartConstant: Chartconstant, private router: Router,
    private injector: Injector, public datepipe: DatePipe,
    private floodForecastUtils: FloodForecastUtilsService,
    private modalSrv: NgbModal,
    private utils: UtilsSharedModule,
    private floodForecastService : FloodForecastMapService,
    private deviceService: DeviceDetectorService) {
    const stateUrlId = this.route.snapshot.paramMap.get('id');
    this.stateUrlId = stateUrlId;
    this.STATENAME = ProjConstants.IDTOSTATENAMEMAPPING[stateUrlId];
    this.regionSelected = this.floodForecastUtils.getFloodForecastSelectedRegionValue();
    if (isNullOrUndefined(this.regionSelected)) {
      this.regionSelected = 'southZone';
    }
    this.selectedLocation = '';
    this.showThrobber = false;
    this.showBottomBar = false;
    this.bottomBarMenuSelectedIndex = 0;
    this.styleObjforBottomBar = { width: 0 };
    this.postData = {};
    this.bottomBarColumns.push('Component');
    this.geoJsonData = {};
    this.dateList = [];
    this.onResize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.screenWidth = window.innerWidth;
  }

  ngOnInit() {
    this.applicationName = this.router.url.split('/')[1];
    this.componentName = this.router.url.split('/')[2];
    this.urlParams = this.floodForecastUtils.checkUrlParams(this.route.snapshot.params);
    this.deviceInfo = this.deviceService.getDeviceInfo();
    setTimeout(() => {
      if (this.deviceInfo['deviceType'] === 'desktop' && this.screenWidth >= 768) {
        this.type = this.router.url.split('/')[1];
      }
    }, 1000);
  }

  ngAfterViewInit() {
    this.initMap();
    this.getBasinData();
    // this.addRainfallHeatMap(this.floodForecastUtils.getFloodForecastRfFilterParamsValue());
    // this.setBaseOverlayLayersOnMap();
    // this.getBasinData();
    // this.addBaseLayers(this.layerList);
    // this.serviceMap.addTimeBasedLayers(this, this.layerList);
    return;
  }

  addRainfallHeatMap(params, visible?) {
    if (isUndefined(params['component'])) {
      return;
    }
    if (isUndefined(params['visible']) || params['visible'] === false) {
      return;
    }
    const postDate = Object.assign({}, params);
    delete postDate['visible'];
    const layer = {
      url: 'rf/rfMap',
      postData: postDate
    };
    const shpBoundaryOptions = this.otherOptions['metaData']
    ['FloodForecastMapOptions'][this.regionSelected]['shpBoundaryOptions'];
    this.showThrobber = true;
    const oldLayer = this.layersList['overlayLayers']['Rainfall HeatMap'];
    // this.removeOverlayLayerByName('Rainfall HeatMap');
    this.removeOverlayLayersByType('HEATMAP');
    this.serviceMap.createCroppedHeatMapLayer(layer, shpBoundaryOptions, this.regionSelected).then(layer => {
      if (!isNullOrUndefined(layer['layer'])) {
        const noOfDays = this.utils.getNumberOfDaysBetweenTwoModelDates(postDate['sDate'], postDate['eDate'], postDate['format']);
        layer['layer'].options.group = 'Rainfall Actual';
        layer['layer'].options.name = 'Rainfall HeatMap';
        layer['layer'].options.type = 'HEATMAP';
        layer['layer'].options.visible = true;
        let legendType = 'LOW';
        if (noOfDays >= 6) {
          legendType = 'HIGH';
        }
        layer['layer'].options.legendData = Object.assign({}, this.otherOptions['metaData'].RainfallLegend[legendType].legendData);
        layer['layer'].options.legendData.title = "Rainfall Level";
        if (oldLayer) {
          layer['layer'].options.visible = oldLayer.options.visible;
        }
        if (visible) {
          layer['layer'].options.visible = true;
        }
        this.layersList['overlayLayers']['Rainfall HeatMap'] = layer['layer'];
        if (layer['layer'].options.visible) {
          layer['layer'].addTo(this.map);
        }
        this.addForecastLegend(layer['layer'], this.htmlLegend, false);
      }
      this.showThrobber = false;
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  ngOnChanges() { }

  private initMap(): void {
    this.map = L.map('map', this.otherOptions['metaData']['FloodForecastMapOptions'][this.regionSelected]);
    this.injectService();
    this.addSubscriptions();
    this.addZoomBar();
    this.createPanes();
    // this.addLegend();
    this.addMapEvents();
    this.setUrlParams();
  }

  public injectService() {
    this.serviceMap = this.injector.get<any>(this.otherOptions['service']);
  }

  addSubscriptions() {
    this.regionSelectedSubscription = this.floodForecastUtils.getFloodForecastSelectedRegion().subscribe(name => {
      if (name === 'godavari_hec_hms') {
        this.metaData = this.metaDataobj.hecHms;
      } else {
        this.metaData = this.metaDataobj.basin;
      }
      if (this.initSubScriptions[0]) {
        this.initSubScriptions[0] = false;
        return;
      }
      if (name !== this.regionSelected) {
        this.regionSelected = name;
        // this.map.remove();
        // this.initMap();
        // this.getBasinData();
        // this.removeAllLayersOnMap();
        this.removeOverlayLayers();
        this.removeFlowLabels();
        this.floodForecastPointGeoJson = undefined;
        this.setMapView();
        // this.floodForecastWMSTileLayerConfig = this.setLayersBasedOnView(this.floodForecastWMSTileLayerConfig, this.regionSelected);
        this.setOverlayLayersOnMap();
        this.addRainfallHeatMap(this.floodForecastUtils.getFloodForecastRfFilterParamsValue(), false);
        // this.serviceMap.changeLayersOnRegionChange(this.floodForecastWMSTileLayerConfig, this.layersList.overlayLayers, this);
        if (this.regionSelected === 'godavariBasin' && isNullOrUndefined(this.layersList.overlayLayers['Godavari Label Markers'])) {
          this.addSubBasinLabel();
        }
        if (this.regionSelected === 'godavari_hec_hms' && isNullOrUndefined(this.layersList.overlayLayers['Godavari Label Markers'])) {
          this.addSubBasinLabel();
        }
      }
    });
    this.subscriptions.push(this.regionSelectedSubscription);

    this.removeCatchmentSubscription = this.floodForecastUtils.getFloodForecastRemoveCatchment().subscribe(value => {
      if (!isNullOrUndefined(value) && value) {
        this.layersList.overlayLayers['Full Catchment'].clearLayers();
        this.layersList.overlayLayers['Self Catchment'].clearLayers();
      }
    })
    this.subscriptions.push(this.removeCatchmentSubscription);

    this.spinnerSubscription = this.serviceMap.isActiveSpinner.subscribe((value) => {
      if (this.initSubScriptions[1]) {
        this.initSubScriptions[1] = false;
        return;
      }
      this.showThrobber = value;
    });
    this.subscriptions.push(this.spinnerSubscription);

    this.openDataTabSubscription = this.serviceMap.isOpenDataTab.subscribe((value) => {
      if (this.initSubScriptions[2]) {
        this.initSubScriptions[2] = false;
        return;
      }
      this.dataTabToggleVal = value;
      this.revalidateMap();
    });
    this.subscriptions.push(this.openDataTabSubscription);

    this.floodForecastFilterSubscription = this.floodForecastUtils.getFloodForecastRfFilterParams()
      .subscribe(params => {
        // if(this.initSubScriptions[3]) {
        //   this.initSubScriptions[3] = false;
        //   return;
        // }
        this.addRainfallHeatMap(params, true);
      });
    this.subscriptions.push(this.floodForecastFilterSubscription);

    this.navigationSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
      }
      if (event instanceof NavigationEnd) {
        this.urlParams = this.utils.checkUrlParams(this.route.snapshot.params);
        // console.log(this.urlParams['showSensorLayer']);
        if (this.urlParams['showSensorLayer'] == 'true') {
          this.removeOverlayLayerByName('sensorLayer');
          this.removeOverlayLayerByName('sensorLayerAll');
          // this.plotSensors(true);
        }
      }
      if (event instanceof NavigationError) {
        // console.log(event.error); // Hide loading indicator  // Present error to user
      }
    });
    this.subscriptions.push(this.navigationSubscription);
  }

  addZoomBar() {
    const zoomBarControl = new (L as any).control.zoomBars();
    zoomBarControl.addTo(this.map);
  }

  private createPanes() {
    this.otherOptions['metaData']['FloodForecastMapPanes'].forEach(pane => {
      this.map.createPane(pane.name);
      this.map.getPane(pane.name).style.zIndex = pane.zindex;
    });
  }

  public addMapEvents() {
    this.map.on({
      zoomend: () => {
        if (!this.floodForecastPointGeoJson) { return; }
        if (!this.metaData) { return; }
        if (!this.serviceMap) { return; }
        this.removeFlowLabels();
        this.serviceMap.addZoomLabels(this.floodForecastPointGeoJson, this.map, this.otherOptions['labelMetaData']);
      }
    });
  }

  public setUrlParams() {
    if (this.otherOptions['urlParams']) {
      this.urlParams = this.otherOptions['urlParams'];
    }
  }

  revalidateMap(): void {
    window.dispatchEvent(new Event('resize'));
    if (this.map) {
      setTimeout(() => {
        this.map.invalidateSize();
      }, 200);
    }
  }

  dataTabToggle(value?: boolean) {
    // console.log(moduleName, data['maponclick'], this.dataTabToggleVal);
    this.revalidateMap();
    this.dataTabToggleVal = !this.dataTabToggleVal;

    if (this.dataTabToggleVal) {
      if (document.getElementById('MapContainer').offsetWidth < 1600) {
        document.documentElement.style.setProperty('--opacite', 'none');
        document.documentElement.style.setProperty('--lPercent', '70%');
      }
    } else {
      document.documentElement.style.setProperty('--opacite', 'display');
      document.documentElement.style.setProperty('--lPercent', '50%');
    }
  }

  removeAllLayers() {
    for (const index in this.activeLayers) {
      if (index) {
        const layer = this.activeLayers[index];
        if (!isUndefined(layer) && !isNullOrUndefined(layer['layer'])) {
          this.map.removeLayer(layer['layer']);
        }
        this.activeLayers[index] = 'deleted';
      }
    }
    this.activeLayers = this.activeLayers.filter(item => item != 'deleted');
    this.map.eachLayer((layer: any) => this.map.removeLayer(layer));
  }

  removeAllLayersOnMap() {
    // console.log(this.map)
    this.map.eachLayer((layer) => {
      // console.log(layer)
      layer.remove();
    });
    this.activeLayers = [];
  }

  collapse(event: any) {
    this.collapsebutton = event;
  }

  activeMenu(event: any) {
    this.activeSideMenu = event;
  }

  setMapView() {
    this.map.flyTo(L.latLng(this.otherOptions['metaData']['FloodForecastMapOptions'][this.regionSelected]['center'][0],
      this.otherOptions['metaData']['FloodForecastMapOptions'][this.regionSelected]['center'][1]),
      this.otherOptions['metaData']['FloodForecastMapOptions'][this.regionSelected]['zoom'], {
      duration: 0.5,
    });
  }

  getBasinData() {
    this.serviceMap.getMetaDataForAllPoints().subscribe(data => {
      this.metaData = data; // angular.fromJson(angular.toJson(data));
      this.metaDataobj.basin = data;
      this.setBaseLayersOnMap();
      this.setOverlayLayersOnMap();
    });
    this.serviceMap.getHecHmsMetaDataForAllPoints().subscribe(data => {
      // this.metaData = data; // angular.fromJson(angular.toJson(data));
      this.metaDataobj.hecHms = data;
    })
    const interval = this.view.toUpperCase();
    this.basinTableDataForImpPoints = {};
    this.tableDataToDiplay = {};
    const getBasinTabledata = this.serviceMap.getBasinTableDataNew(interval).subscribe(basinData => {
      return basinData;
    }, () => {
      // TO DO
    });
    const getLatestKnownData = this.serviceMap.getLatestKnownTableData().subscribe(latestKnownData => {
      return latestKnownData;
    }, () => {
      // TO DO
    });
    const getSummaryData = this.serviceMap.getReservoirMetaData('southzone').subscribe(summaryData => {
      return summaryData;
    }, () => {
      // TO DO
    });
    const promises: any = {};
    promises.basinData = getBasinTabledata;
    promises.latestKnownData = getLatestKnownData;
    promises.summaryData = getSummaryData;
  }

  setBaseLayersOnMap() {
    // creating the tile layers to add onto the map object
    this.baseLayers = this.serviceMap.createBaseTileLayers(this.otherOptions['metaData']['FloodForecastBaseLayerOptions']);
    this.layersList.baseLayers = Object.assign(this.layersList.baseLayers, this.baseLayers);
    // adding the base layer to map object
    this.serviceMap.setBaseLayer(this.baseLayers, this);
  }
  getCurrentDayInflowTimestamp(){
    let date = new Date();
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    let time = date.getTime().toString();
    let timestepvalue = Number(time.substring(0,10) + '000')
    return timestepvalue;
  }



  setOverlayLayersOnMap() {
    let timeStamp = this.getCurrentDayInflowTimestamp();
    if (!isNullOrUndefined(this.htmlLegend)) {
      this.map.removeControl(this.htmlLegend);
    }
    const htmlLegend = this.floodForecastUtils.createLegend();
    this.map.addControl(htmlLegend);
    this.htmlLegend = htmlLegend;

    this.floodForecastWMSTileLayerConfig = this.serviceMap.getApplicationBasedLayer('WMS', this.otherOptions['metaData']);
    this.floodForecastWMSTileLayerConfig = this.setLayersBasedOnView(this.floodForecastWMSTileLayerConfig, this.regionSelected);
    this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, this.serviceMap.setWmsTileLayers(this.floodForecastWMSTileLayerConfig, this));
    this.addForecastLegend(this.layers.overlaylayers, htmlLegend, true);

    this.floodForecastGeoJSONLayersConfig = this.serviceMap.getApplicationBasedLayer('GEOJSON', this.otherOptions['metaData']);
    this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, this.serviceMap.setGeoJSONOverlays(this.floodForecastGeoJSONLayersConfig, this));

    let updatedView = this.regionSelected;
    if (this.regionSelected === 'godavariBasin') {
      this.addSubBasinLabel();
      updatedView = 'godavari';
    } else if (this.regionSelected === 'godavari_hec_hms') {
      this.addSubBasinLabel();
      updatedView = 'godavari';
    } else if (this.regionSelected === 'southZone') {
      updatedView = 'southzone';
    } else if (this.regionSelected === 'krishnaBasin') {
      updatedView = 'krishna';
    } else {
      updatedView = 'tsgodavari';
    }

    let basinView: string;
    if (this.regionSelected === 'godavariBasin') {
      // this.addSubBasinLabel();
      basinView = 'godavariNew';
    } else if (this.regionSelected === 'southZone') {
      basinView = 'southzone';
    } else if (this.regionSelected === 'krishnaBasin') {
      basinView = 'krishnaNew';
    } else {
      basinView = 'tsgodavari';
    }

    // // NOTE : RAINFALL FORECAST HEATMAP ONLY "for next 7 days"
    // this.serviceMap.getImageLayersForFloodForecast('HEATMAP', updatedView, this.otherOptions['metaData'])().then((data) => {
    //   this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, this.serviceMap.setImageLayers(this.map, data));
    //   // this.addForecastLegend(this.layers.overlaylayers,htmlLegend,true);
    // });

    // // NOTE : RAINFALL ACTUAL HEATMAP ONLY "today dbyes, last3day,yest"
    // this.serviceMap.getActualHeatMapForFloodForecast('HEATMAP', basinView).then((data) => {
    //   this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, this.serviceMap.setImageLayers(this.map, data));
    //   this.addForecastLegend(this.layers.overlaylayers, htmlLegend, true);
    // });


    // NOTE :: RAINFALL AND FORECAST ACTUAL HEATMAPS FROM APWRIMS
    const shpBoundaryOptions = this.otherOptions['metaData']
    ['FloodForecastMapOptions'][this.regionSelected]['shpBoundaryOptions'];
    // this.throbbers[4] = true;
    // this.serviceMap.getRainfallActualAndForecastHeatMapsFromApwrims(this.otherOptions).then((data) => {
    //   this.serviceMap.setCroppedImageLayers(data, this.map, shpBoundaryOptions, this.regionSelected).then(imageLayers => {
    //     this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, imageLayers);
    //     this.throbbers[4] = false;
    //     this.addForecastLegend(imageLayers, htmlLegend, true);
    //   });
    // });  //for rainfall heatmap

    let geoJsonLayer = null;
    const filter = {
      filter: this.getfilter(this.regionSelected)
    };
    this.throbbers[0] = true;
    this.serviceMap.getGeoJSONData('flood_forecast_points_v7', filter).subscribe(jsonData => {
      //Here! 2
      this.serviceMap.drawFloodForecastPoints(jsonData, 'Inflow', this, this.metaData, this.modalSrv, this.urlParams, this.otherOptions['labelMetaData'], this.stateUrlId, this.regionSelected).then((data) => {
        geoJsonLayer = data;
        this.floodForecastPointGeoJson = jsonData;
        geoJsonLayer.options.group = 'Flood Forecast';
        geoJsonLayer.options.showOnSelector = true;
        geoJsonLayer.options.name = 'Flood forecast rivers';
        geoJsonLayer.options.visible = true;
        geoJsonLayer.options.legendData = this.otherOptions['metaData'].FloodForecastRiver['Flow Node'].legendData;
        const geoJsonLayerObject = { 'Flood forecast rivers': geoJsonLayer };
        this.addForecastLegend(geoJsonLayer, htmlLegend, false);
        geoJsonLayer.addTo(this.map);

        this.throbbers[0] = false;
        // this.activeLayers.push(geoJsonLayer);
        this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, geoJsonLayerObject);
        // angular.extend(vm.layers.overlaylayers, geoJsonLayerObject);
        // updateLayersBasedOnView(map);
      });
    });
    this.throbbers[1] = true;
    this.serviceMap.getGeoJSONData('ALL_INDIA_RIVER_NETWORK', filter).subscribe(jsonData => {
      //Here! 2
      this.serviceMap.drawFloodForecastPoints(jsonData, 'Inflow', this, this.metaData, this.modalSrv, this.urlParams, this.otherOptions['labelMetaData'], this.stateUrlId, this.regionSelected).then((data) => {
        geoJsonLayer = data;
        this.floodForecastPointGeoJson = jsonData;
        geoJsonLayer.options.group = 'Flood Forecast';
        geoJsonLayer.options.showOnSelector = true;
        geoJsonLayer.options.name = 'Flood forecast rivers';
        geoJsonLayer.options.visible = true;
        geoJsonLayer.options.legendData = this.otherOptions['metaData'].FloodForecastRiver['Rivers'].legendData;
        const geoJsonLayerObject = { 'Flood forecast rivers': geoJsonLayer };
        this.addForecastLegend(geoJsonLayer, htmlLegend, false);
        geoJsonLayer.addTo(this.map);

        this.throbbers[1] = false;
        // this.activeLayers.push(geoJsonLayer);
        this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, geoJsonLayerObject);
        // angular.extend(vm.layers.overlaylayers, geoJsonLayerObject);
        // updateLayersBasedOnView(map);
      });
    });

    // this.throbbers[1] = true;
    // this.serviceMap.getGeoJSONData('flood_forecast_river_links_v7', filter).subscribe(jsonData => {
    //   // this.floodForecastService.getBasinDailyTableData().subscribe(riverData => {
    //   this.serviceMap.drawFloodForecastRivers(jsonData, 'Inflow', this.metaData, this.modalSrv, this.urlParams, this.stateUrlId).then((data) => {
    //     const riverLayer: any = data;
    //     riverLayer.options.group = 'Flood Forecast';
    //     riverLayer.options.showOnSelector = true;
    //     riverLayer.options.name = 'Flood forecast rivers';
    //     riverLayer.options.visible = true;
    //     riverLayer.options.legendData = this.otherOptions['metaData'].floodforecastRiver['Rivers'].legendData;
    //     // riverLayer.options.legendData = this.otherOptions['metaData'].floodforecastRiver['Reservoir'].legendData;
    //     const geoJsonLayerObject = { 'Flood forecast rivers': riverLayer };
    //     this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, geoJsonLayerObject);
    //     this.addForecastLegend(riverLayer, htmlLegend, false);
    //     riverLayer.addTo(this.map);

    //     this.throbbers[1] = false;
    //     // this.activeLayers.push(riverLayer);
    //     /*
    //       NOTE: when apply filter is true i.e laod rainfall heatmap by datepicker. In that case spinner
    //       would be false once heatmap and sensor relaoded on map. Other wise if no datehas been picked
    //       then remove the spinner once river and point layer added on map.
    //     */
    //     if (this.urlParams.applyFilter !== 'true') {
    //       this.showThrobber = false;
    //     }
    //     this.showThrobber = false;
    //   });
    //   // });
    // });
    // this.throbbers[2] = true;
    // this.serviceMap.getGeoJSONData('flood_forecast_river_links_v7', filter).subscribe(jsonData => {
    //   // this.floodForecastService.getBasinDailyTableData().subscribe(riverData => {
    //   this.serviceMap.drawFloodForecastRivers(jsonData, 'Inflow', this.metaData, this.modalSrv, this.urlParams, this.stateUrlId).then((data) => {
    //     const riverLayer: any = data;
    //     riverLayer.options.group = 'Flood Forecast';
    //     riverLayer.options.showOnSelector = true;
    //     riverLayer.options.name = 'Flood forecast rivers';
    //     riverLayer.options.visible = true;
    //     riverLayer.options.legendData = this.otherOptions['metaData'].floodforecastRiver['Reservoir'].legendData;
    //     const geoJsonLayerObject = { 'Flood forecast rivers': riverLayer };
    //     this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, geoJsonLayerObject);
    //     this.addForecastLegend(riverLayer, htmlLegend, false);
    //     riverLayer.addTo(this.map);

    //     this.throbbers[2] = false;
    //     // this.activeLayers.push(riverLayer);
    //     /*
    //       NOTE: when apply filter is true i.e laod rainfall heatmap by datepicker. In that case spinner
    //       would be false once heatmap and sensor relaoded on map. Other wise if no datehas been picked
    //       then remove the spinner once river and point layer added on map.
    //     */
    //     if (this.urlParams.applyFilter !== 'true') {
    //       this.showThrobber = false;
    //     }
    //     this.showThrobber = false;
    //   // });
    //   });
    // });

    // this.throbbers[3] = true;
    // this.serviceMap.getGeoJSONData2('tamilnadu_pennaiyar_river_network', filter).subscribe(jsonData => {
    //     this.floodForecastService.getTNRiverColorData(timeStamp).subscribe(riverData => {

    //   this.serviceMap.drawFloodForecastRivers(jsonData, 'Inflow', this.metaData, this.modalSrv, this.urlParams, this.stateUrlId,riverData).then((data) => {
    //     const riverLayer: any = data;
    //     riverLayer.options.group = 'Flood Forecast';
    //     riverLayer.options.showOnSelector = true;
    //     riverLayer.options.name = 'Flood forecast rivers';
    //     riverLayer.options.visible = true;
    //     riverLayer.options.legendData = this.otherOptions['metaData'].floodforecastRiver['Reservoir'].legendData;
    //     const geoJsonLayerObject = { 'Flood forecast rivers': riverLayer };
    //     this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, geoJsonLayerObject);
    //     // this.addForecastLegend(riverLayer, htmlLegend, false);
    //     riverLayer.addTo(this.map);

    //     this.throbbers[3] = false;
    //     // this.activeLayers.push(riverLayer);
    //     /*
    //       NOTE: when apply filter is true i.e laod rainfall heatmap by datepicker. In that case spinner
    //       would be false once heatmap and sensor relaoded on map. Other wise if no datehas been picked
    //       then remove the spinner once river and point layer added on map.
    //     */
    //     if (this.urlParams.applyFilter !== 'true') {
    //       this.showThrobber = false;
    //     }
    //     this.showThrobber = false;
    //   });
    // });
    // });
    // this.throbbers[4] = true;
    // this.serviceMap.getGeoJSONData2('tamilnadu_pennaiyar_reservoir_rivergauge_points', filter).subscribe(jsonData => {
    //   //Here! 2
    //   this.serviceMap.drawFloodForecastPoints(jsonData, 'Inflow', this, this.metaData, this.modalSrv, this.urlParams, this.otherOptions['labelMetaData'], this.stateUrlId, this.regionSelected).then((data) => {
    //     geoJsonLayer = data;
    //     this.floodForecastPointGeoJson = jsonData;
    //     geoJsonLayer.options.group = 'Flood Forecast';
    //     geoJsonLayer.options.showOnSelector = true;
    //     geoJsonLayer.options.name = 'Flood forecast points';
    //     geoJsonLayer.options.visible = true;
    //     geoJsonLayer.options.legendData = this.otherOptions['metaData'].FloodForecastRiver['Flow Node'].legendData;
    //     const geoJsonLayerObject = { 'Flood forecast points': geoJsonLayer };
    //     // this.addForecastLegend(geoJsonLayer, htmlLegend, false);
    //     geoJsonLayer.addTo(this.map);

    //     this.throbbers[4] = false;
    //     // this.activeLayers.push(geoJsonLayer);
    //     this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, geoJsonLayerObject);
    //     // angular.extend(vm.layers.overlaylayers, geoJsonLayerObject);
    //     // updateLayersBasedOnView(map);
    //   });
    // });
    // this.throbbers[5] = true;
    // this.serviceMap.getGeoJSONDataKW('flood_forecast_river_network', filter).subscribe(jsonData => {
    //   this.floodForecastService.getKERiverColorData(timeStamp).subscribe(resdata => {
    //   this.serviceMap.drawFloodForecastRivers(jsonData, 'Inflow', this.metaData, this.modalSrv, this.urlParams, this.stateUrlId,resdata).then((data) => {
    //     const riverLayer: any = data;
    //     riverLayer.options.group = 'Flood Forecast';
    //     riverLayer.options.showOnSelector = true;
    //     riverLayer.options.name = 'Flood forecast rivers';
    //     riverLayer.options.visible = true;
    //     riverLayer.options.legendData = this.otherOptions['metaData'].floodforecastRiver['Reservoir'].legendData;
    //     const geoJsonLayerObject = { 'Flood forecast rivers': riverLayer };
    //     this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, geoJsonLayerObject);
    //     // this.addForecastLegend(riverLayer, htmlLegend, false);
    //     riverLayer.addTo(this.map);

    //     this.throbbers[5] = false;
    //     // this.activeLayers.push(riverLayer);
    //     /*
    //       NOTE: when apply filter is true i.e laod rainfall heatmap by datepicker. In that case spinner
    //       would be false once heatmap and sensor relaoded on map. Other wise if no datehas been picked
    //       then remove the spinner once river and point layer added on map.
    //     */
    //     if (this.urlParams.applyFilter !== 'true') {
    //       this.showThrobber = false;
    //     }
    //     this.showThrobber = false;
    //   });
    //   });
    // });
    // this.throbbers[6] = true;
    // this.serviceMap.getGeoJSONDataOD('odisha_mahanadi_river_network', filter).subscribe(jsonData => {
    //   this.floodForecastService.getODMahanadiRiverColorData(timeStamp).subscribe(odMdata => {
    //   this.serviceMap.drawFloodForecastRivers(jsonData, 'Inflow', this.metaData, this.modalSrv, this.urlParams, this.stateUrlId,odMdata).then((data) => {
    //     const riverLayer: any = data;
    //     riverLayer.options.group = 'Flood Forecast';
    //     riverLayer.options.showOnSelector = true;
    //     riverLayer.options.name = 'Flood forecast rivers';
    //     riverLayer.options.visible = true;
    //     riverLayer.options.legendData = this.otherOptions['metaData'].floodforecastRiver['Reservoir'].legendData;
    //     const geoJsonLayerObject = { 'Flood forecast rivers': riverLayer };
    //     this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, geoJsonLayerObject);
    //     // this.addForecastLegend(riverLayer, htmlLegend, false);
    //     riverLayer.addTo(this.map);

    //     this.throbbers[6] = false;
    //     // this.activeLayers.push(riverLayer);
    //     /*
    //       NOTE: when apply filter is true i.e laod rainfall heatmap by datepicker. In that case spinner
    //       would be false once heatmap and sensor relaoded on map. Other wise if no datehas been picked
    //       then remove the spinner once river and point layer added on map.
    //     */
    //     if (this.urlParams.applyFilter !== 'true') {
    //       this.showThrobber = false;
    //     }
    //     this.showThrobber = false;
    //   });
    //   });
    // });
    // this.throbbers[7] = true;
    // this.serviceMap.getGeoJSONDataOD('odisha_baitarni_river_network', filter).subscribe(jsonData => {
    //   this.floodForecastService.getODBaitaraniRiverColorData(timeStamp).subscribe(odBadata => {
    //   this.serviceMap.drawFloodForecastRivers(jsonData, 'Inflow', this.metaData, this.modalSrv, this.urlParams, this.stateUrlId,odBadata).then((data) => {
    //     const riverLayer: any = data;
    //     riverLayer.options.group = 'Flood Forecast';
    //     riverLayer.options.showOnSelector = true;
    //     riverLayer.options.name = 'Flood forecast rivers';
    //     riverLayer.options.visible = true;
    //     riverLayer.options.legendData = this.otherOptions['metaData'].floodforecastRiver['Reservoir'].legendData;
    //     const geoJsonLayerObject = { 'Flood forecast rivers': riverLayer };
    //     this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, geoJsonLayerObject);
    //     // this.addForecastLegend(riverLayer, htmlLegend, false);
    //     riverLayer.addTo(this.map);

    //     this.throbbers[7] = false;
    //     // this.activeLayers.push(riverLayer);
    //     /*
    //       NOTE: when apply filter is true i.e laod rainfall heatmap by datepicker. In that case spinner
    //       would be false once heatmap and sensor relaoded on map. Other wise if no datehas been picked
    //       then remove the spinner once river and point layer added on map.
    //     */
    //     if (this.urlParams.applyFilter !== 'true') {
    //       this.showThrobber = false;
    //     }
    //     this.showThrobber = false;
    //   });
    //   });
    // });
    // this.throbbers[8] = true;
    // this.serviceMap.getGeoJSONDataOD('odisha_brahmani_river_network', filter).subscribe(jsonData => {
    //   this.floodForecastService.getODBhramaniRiverColorData(timeStamp).subscribe(odBrdata => {
    //   this.serviceMap.drawFloodForecastRivers(jsonData, 'Inflow', this.metaData, this.modalSrv, this.urlParams, this.stateUrlId,odBrdata).then((data) => {
    //     const riverLayer: any = data;
    //     riverLayer.options.group = 'Flood Forecast';
    //     riverLayer.options.showOnSelector = true;
    //     riverLayer.options.name = 'Flood forecast rivers';
    //     riverLayer.options.visible = true;
    //     riverLayer.options.legendData = this.otherOptions['metaData'].floodforecastRiver['Reservoir'].legendData;
    //     const geoJsonLayerObject = { 'Flood forecast rivers': riverLayer };
    //     this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, geoJsonLayerObject);
    //     // this.addForecastLegend(riverLayer, htmlLegend, false);
    //     riverLayer.addTo(this.map);

    //     this.throbbers[8] = false;
    //     // this.activeLayers.push(riverLayer);
    //     /*
    //       NOTE: when apply filter is true i.e laod rainfall heatmap by datepicker. In that case spinner
    //       would be false once heatmap and sensor relaoded on map. Other wise if no datehas been picked
    //       then remove the spinner once river and point layer added on map.
    //     */
    //     if (this.urlParams.applyFilter !== 'true') {
    //       this.showThrobber = false;
    //     }
    //     this.showThrobber = false;
    //   });
    //   });
    // });
    // this.throbbers[9] = true;
    // this.serviceMap.getGeoJSONDataOD('odisha_rushikulya_river_network', filter).subscribe(jsonData => {
    //   this.floodForecastService.getODRushikulyaRiverColorData(timeStamp).subscribe(odRudata => {
    //   this.serviceMap.drawFloodForecastRivers(jsonData, 'Inflow', this.metaData, this.modalSrv, this.urlParams, this.stateUrlId,odRudata).then((data) => {
    //     const riverLayer: any = data;
    //     riverLayer.options.group = 'Flood Forecast';
    //     riverLayer.options.showOnSelector = true;
    //     riverLayer.options.name = 'Flood forecast rivers';
    //     riverLayer.options.visible = true;
    //     riverLayer.options.legendData = this.otherOptions['metaData'].floodforecastRiver['Reservoir'].legendData;
    //     const geoJsonLayerObject = { 'Flood forecast rivers': riverLayer };
    //     this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, geoJsonLayerObject);
    //     // this.addForecastLegend(riverLayer, htmlLegend, false);
    //     riverLayer.addTo(this.map);

    //     this.throbbers[9] = false;
    //     // this.activeLayers.push(riverLayer);
    //     /*
    //       NOTE: when apply filter is true i.e laod rainfall heatmap by datepicker. In that case spinner
    //       would be false once heatmap and sensor relaoded on map. Other wise if no datehas been picked
    //       then remove the spinner once river and point layer added on map.
    //     */
    //     if (this.urlParams.applyFilter !== 'true') {
    //       this.showThrobber = false;
    //     }
    //     this.showThrobber = false;
    //   });
    //   });
    // });
    // this.throbbers[10] = true;
    this.serviceMap.getGeoJSONDataKW('HEATWAVE:ALL_INDIA_RESERVOIR_POINTS', filter).subscribe(jsonData => {
      //Here! 2
      this.serviceMap.drawFloodForecastPoints(jsonData, 'Inflow', this, this.metaData, this.modalSrv, this.urlParams, this.otherOptions['labelMetaData'], this.stateUrlId, this.regionSelected).then((data) => {
        geoJsonLayer = data;
        this.floodForecastPointGeoJson = jsonData;
        geoJsonLayer.options.group = 'Flood Forecast';
        geoJsonLayer.options.showOnSelector = true;
        geoJsonLayer.options.name = 'Flood forecast rivers';
        geoJsonLayer.options.visible = true;
        geoJsonLayer.options.legendData = this.otherOptions['metaData'].FloodForecastRiver['Flow Node'].legendData;
        const geoJsonLayerObject = { 'Flood forecast rivers': geoJsonLayer };
        // this.addForecastLegend(geoJsonLayer, htmlLegend, false);
        geoJsonLayer.addTo(this.map);

        this.throbbers[10] = false;
        // this.activeLayers.push(geoJsonLayer);
        this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, geoJsonLayerObject);
        // angular.extend(vm.layers.overlaylayers, geoJsonLayerObject);
        // updateLayersBasedOnView(map);
      });
    });
    // this.throbbers[12] = true;
    // this.serviceMap.getGeoJSONDataOD('mahanadi_rushikulya_baitarani_brahmani_reservoir_rivergauge', filter).subscribe(jsonData => {
    //   //Here! 2
    //   this.serviceMap.drawFloodForecastPoints(jsonData, 'Inflow', this, this.metaData, this.modalSrv, this.urlParams, this.otherOptions['labelMetaData'], this.stateUrlId, this.regionSelected).then((data) => {
    //     geoJsonLayer = data;
    //     this.floodForecastPointGeoJson = jsonData;
    //     geoJsonLayer.options.group = 'Flood Forecast';
    //     geoJsonLayer.options.showOnSelector = true;
    //     geoJsonLayer.options.name = 'Flood forecast points';
    //     geoJsonLayer.options.visible = true;
    //     geoJsonLayer.options.legendData = this.otherOptions['metaData'].FloodForecastRiver['Flow Node'].legendData;
    //     const geoJsonLayerObject = { 'Flood forecast points': geoJsonLayer };
    //     // this.addForecastLegend(geoJsonLayer, htmlLegend, false);
    //     geoJsonLayer.addTo(this.map);

    //     this.throbbers[12] = false;
    //     // this.activeLayers.push(geoJsonLayer);
    //     this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, geoJsonLayerObject);
    //     // angular.extend(vm.layers.overlaylayers, geoJsonLayerObject);
    //     // updateLayersBasedOnView(map);
    //   });
    // });


    // });
    // this.plotSensors(false);
  }

  plotSensors(isVisible) {
    if (!this.htmlLegend) {
      this.htmlLegend = this.floodForecastUtils.createLegend();
    }
    const startTs = this.getTimestampFromDate()[0];
    const endTs = this.getTimestampFromDate()[1];
    let basinName, regionName;
    if (this.regionSelected == 'godavariBasin') {
      regionName = 'GODAVARI-BASIN';
      basinName = 'godavari';
    } else if (this.regionSelected === 'godavari_hec_hms') {
      regionName = 'GODAVARI-BASIN';
      basinName = 'godavari';
    } else if (this.regionSelected === 'godavariTelangana') {
      regionName = 'GODAVARI-TELANGANA';
      basinName = 'godavari_telangana';
    } else if (this.regionSelected === 'southZone') {
      regionName = 'SOUTHZONE_FLOW_NETWORK';
      basinName = 'southzone';
    } else if (this.regionSelected === 'krishnaBasin') {
      regionName = 'KRISHNA_BASIN';
      basinName = 'krishnabasin';
    } else if (this.regionSelected === 'ap') {
      regionName = 'ANDHRA_PRADESH';
      basinName = 'ap';
    } else if (this.regionSelected === 'pennarBasin') {
      regionName = 'PENNAR_BASIN';
      basinName = 'pennarBasin';
    } else if (this.regionSelected === 'vamsadharaBasin') {
      regionName = 'VAMSADHARA_BASIN';
      basinName = 'vamsadharaBasin';
    } else if (this.regionSelected === 'nagavaliBasin') {
      regionName = 'NAGAVALI_BASIN';
      basinName = 'nagavaliBasin';
    } else if (this.regionSelected === 'MahanadiBasin') {
      regionName = 'MAHANADI_BASIN';
      basinName = 'MahanadiBasin';
    } else if (this.regionSelected === 'CauveryBasin') {
      regionName = 'CAUVERY_BASIN';
      basinName = 'CauveryBasin';
    } else {
      this.removeOverlayLayerByName('sensorLayer');
      this.removeOverlayLayerByName('sensorLayerAll');
      return;
    }
    // console.log(this.urlParams);
    // this.serviceMap.processLegendDate(startTs, endTs).then((legendData) => {
    const legendType = this.getRainfallLegend(startTs, endTs);
    const legendData = this.otherOptions.metaData.rainfallLegendValues[legendType];
    const legend = Object.assign({}, this.otherOptions['metaData'].RainfallLegend[legendType].legendData);
    legend.title = "Rainfall Sensor Level";
    this.throbbers[2] = true;
    this.serviceMap.processSensorData(regionName, this.urlParams, this.modalSrv, startTs, endTs, legendData, this.map).then((layers: any) => {
      for (const key in layers) {
        const newlayer = layers[key];
        newlayer.options.group = 'Sensor';
        newlayer.options.showOnSelector = true;
        newlayer.options.name = 'sensorLayer';
        newlayer.options.displayName = 'Rainfall Sensor (Reporting Stations)';
        newlayer.options.visible = false;
        newlayer.options.legendData = legend;
        const newlayerObject = {};
        newlayerObject['sensorLayer'] = newlayer;
        // add this layer on map as soon as sensor data comes

        if (this.map.hasLayer(newlayer)) {
          this.map.removeLayer(newlayer);
        }
        this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, newlayerObject);
        if (this.urlParams.applyFilter == 'true' || isVisible) {
          newlayer.options.visible = true;
          this.map.addLayer(this.layersList.overlayLayers['sensorLayer']);
        }
        this.addForecastLegend(newlayer, this.htmlLegend, false);

      }
      this.throbbers[2] = false;
    });

    this.throbbers[3] = true;
    this.serviceMap.processAllSensorData(regionName, this.urlParams, this.modalSrv, startTs, endTs, legendData, this.map).then((layers: any) => {
      for (const key in layers) {
        const newlayer = layers[key];
        newlayer.options.group = 'Sensor';
        newlayer.options.showOnSelector = true;
        newlayer.options.name = 'sensorLayerAll';
        newlayer.options.displayName = 'Rainfall Sensor (All Stations)';
        newlayer.options.visible = false;
        newlayer.options.legendData = legend;
        const newlayerObject = {};
        newlayerObject['sensorLayerAll'] = newlayer;
        // add this layer on map as soon as sensor data comes

        if (this.map.hasLayer(newlayer)) {
          this.map.removeLayer(newlayer);
        }
        this.layersList.overlayLayers = Object.assign({}, this.layersList.overlayLayers, newlayerObject);
        if (this.urlParams.applyFilter == 'true') {
          newlayer.options.visible = true;
          this.map.addLayer(this.layersList.overlayLayers['sensorLayerAll']);
        }
        this.throbbers[3] = false;

        this.addForecastLegend(newlayer, this.htmlLegend, false);

      }
    });

  }

  getRainfallLegend(startTs, endTs) {
    const diffDays = this.utils.getNoOfDaysBetweenTwoTimeStamps(startTs, endTs);
    // console.log(startTs,endTs);
    // console.log(diffDays);
    if (diffDays >= 7) {
      return 'HIGH';
    }
    return 'LOW';
  }

  removeOverlayLayerByName(layerName) {
    const layer = this.layersList['overlayLayers'][layerName];
    if (layer == undefined) { return; }
    if (this.map.hasLayer(layer)) { this.map.removeLayer(layer); }
    delete this.layersList['overlayLayers'][layerName];
  }

  removeOverlayLayersByType(type) {
    const overlayLayers = this.layersList.overlayLayers;
    for (const overlay in this.layersList.overlayLayers) {
      const layer = overlayLayers[overlay];

      if (layer == null || layer == undefined) { continue; }
      if (isNullOrUndefined(layer.options) || isNullOrUndefined(layer.options.type)) { continue; }
      if (layer.options.type == type) {
        if (this.map.hasLayer(layer)) { this.map.removeLayer(layer); }
      }
    }
  }

  removeOverlayLayers() {
    const overlayLayers = this.layersList.overlayLayers;
    for (const overlay in this.layersList.overlayLayers) {
      const layer = overlayLayers[overlay];
      if (layer == null || layer == undefined) { continue; }
      if (this.map.hasLayer(layer)) { this.map.removeLayer(layer); }
    }
  }

  removeFlowLabels() {
    if (this.serviceMap.labelLayerList) {
      for (const index in this.serviceMap.labelLayerList) {
        const layer = this.serviceMap.labelLayerList[index];
        if (layer == null || layer == undefined) { continue; }
        if (this.map.hasLayer(layer)) { this.map.removeLayer(layer); }
      }
    }
    this.serviceMap.labelLayerList = [];
  }

  getTimestampFromDate() {
    // TODO :: Need to verify
    // this.urlParams = this.serviceMap.checkUrlParams(this.route.snapshot.params);
    let year, month, day, startDate, endDate;
    // console.log(this.urlParams);
    if (this.urlParams.timeStep == 'Daily') {
      startDate = this.urlParams.sDate;
      year = startDate.substring(0, 4);
      month = startDate.substring(4, 6);
      day = startDate.substring(6, 8);
      startDate = new Date(year, month - 1, day);

      endDate = this.urlParams.eDate;
      year = endDate.substring(0, 4);
      month = endDate.substring(4, 6);
      day = endDate.substring(6, 8);
      endDate = new Date(year, month - 1, day);
    } else if (this.urlParams.timeStep == 'Monthly') {
      startDate = this.urlParams.sDate;
      year = startDate.substring(0, 4);
      month = startDate.substring(4, 6);
      startDate = new Date(year, month - 1, 1);

      endDate = this.urlParams.eDate;
      year = endDate.substring(0, 4);
      month = endDate.substring(4, 6);
      let leapyear = false;
      if (((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0)) {
        leapyear = true;
      }
      const arr = [1, 3, 5, 7, 8, 10, 12];
      month = parseInt(month);
      if (month == 2 && leapyear) {
        endDate = new Date(year, month - 1, 29);
      } else if (month == 2 && !leapyear) {
        endDate = new Date(year, month - 1, 28);
      } else if (arr.includes(month)) {
        endDate = new Date(year, month - 1, 31);
      } else {
        endDate = new Date(year, month - 1, 30);
      }

    } else if (this.urlParams.timeStep == 'Yearly') {
      startDate = this.urlParams.sDate;
      year = startDate.substring(0, 4);
      startDate = new Date(year, 5, 1);
      endDate = this.urlParams.eDate;
      year = endDate.substring(0, 4);

      year = parseInt(year);
      endDate = new Date(year + 1, 4, 31);
    }

    if (!startDate || !endDate) {
      return null;
      // startDate =new Date("2020-06-01");
      // endDate=new Date();
    }
    startDate.setHours(0, 0, 0, 0);
    let startTs = startDate.getTime();
    startTs = startTs + (8.5 * 3600000);

    endDate.setHours(0, 0, 0, 0);
    let endTs = endDate.getTime();
    endTs = endTs + (8.5 * 3600000);


    // console.log(startTs);
    // console.log(endTs);

    const timeArray = [];
    timeArray[0] = startTs;
    timeArray[1] = endTs;
    return timeArray;
  }

  setLayersBasedOnView(layers, view) {   // for concat layer in flood forecast
    const viewToLayerMap = {
      southZone: ['South Zone', 'South Zone Inverse' , 'Tamilnadu Basin','Kerala Basin' ,'Odisha State'],
      // southZone: ['South Zone', 'South Zone Inverse' , 'Tamilnadu Basin','Odisha State'],
      ap: ['AP', 'AP Inverse'],
      godavariBasin: ['Godavari', 'Godavari Inverse', 'Godavari Self Catchment'],
      godavari_hec_hms: ['Godavari', 'Godavari Inverse', 'Godavari Self Catchment'],
      krishnaBasin: ['Krishna', 'Krishna Inverse'],
      pennarBasin: ['Pennar', 'Pennar Inverse'],
      vamsadharaBasin: ['Vamsadhara', 'Vamsadhara Inverse'],
      nagavaliBasin: ['Nagavali', 'Nagavali Inverse'],
      MahanadiBasin: ['Mahanadi', 'Mahanadi Inverse'],
      CauveryBasin: ['Cauvery'],
      godavariMask: ['Godavari Basin Mask Clip', 'Godavari Basin-Merge Mask Clip'],
      godavariTelangana: ['Godavari Telangana', 'Godavari Telangana Inverse']
    };
    for (const i in layers) {
      if (i) {
        if (viewToLayerMap[view].includes(i)) {
          layers[i].layerOptions.visible = true;
        } else {
          layers[i].layerOptions.visible = false;
        }
        if (this.regionSelected === 'godavariBasin') {

        }
      }
    }
    return layers;
  }

  addSubBasinLabel() {
    const markerLayerGroup = new (L as any).layerGroup();
    for (const key in this.otherOptions['labelMetaData'].SubBasinPlot) {
      if (key) {
        const name = key;
        const gps = this.otherOptions['labelMetaData'].SubBasinPlot[key].gps;
        const htmlLabel = '<div style=\'font-size:' + this.map.getZoom() * 1.4 + 'px;color:black;width:80px\'>' + name + '</div>';
        const divObj = L.divIcon({ className: 'my-div-icon', html: htmlLabel });
        const marker = L.marker(gps, {
          pane: 'group2',
          icon: divObj,
          interactive: false
        });
        markerLayerGroup.addLayer(marker);
      }
    }
    this.map.addLayer(markerLayerGroup);
    this.activeLayers.push(markerLayerGroup);
    this.layersList.overlayLayers = Object.assign(this.layersList.overlayLayers, { 'Godavari Label Markers': markerLayerGroup });
  }

  getfilter(viewName: string) {
    let filter = '';
    // floodForecastMapDataService.getHighlightStations();
    if (viewName === 'ap') {
      filter = 'state = \'Andhra Pradesh\'';
    } else if (viewName === 'godavariBasin' || viewName === 'godavariTelangana' || viewName === 'godavari_hec_hms') {
      filter = 'basin = \'GODAVARI-BASIN\'';
    } else if (viewName === 'krishnaBasin') {
      filter = 'basin = \'Krishna-Basin\'';
    } else if (viewName === 'pennarBasin') {
      filter = 'basin = \'PENNAR-BASIN\'';
    } else if (viewName === 'vamsadharaBasin') {
      filter = 'basin = \'VAMSADARA-BASIN\'';
    } else if (viewName === 'nagavaliBasin') {
      filter = 'basin = \'NAGAVALI-BASIN\'';
    } else if (viewName === 'MahanadiBasin') {
      filter = 'basin = \'MAHANADI-BASIN\'';
    } else if (viewName === 'CauveryBasin') {
      filter = 'basin = \'Cauvery-BASIN\'';
    }
    // else if (viewName === 'godavariTelangana')
    //   filter = "basin = 'Godavari Telangana Basin"
    return filter;
  }

  addForecastLegend(layers, htmllegend, isLayersList) {
    if (isLayersList) {
      for (const key in layers) {
        if (key) {
          const newlayer = layers[key];
          if (newlayer.options.group == 'Rainfall Forecast' || newlayer.options.group == 'Rainfall Actual' ||
            newlayer.options.group === 'Raw Satellite' || newlayer.options.group === 'Inundation Area' ||
            newlayer.options.group == 'Rainfall Forecast') {
            const filterforecastLayer = layers[key];
            const legendData = filterforecastLayer.options.legendData;
            const legendInfoData = this.floodForecastUtils.getLegendData(legendData, filterforecastLayer);
            const legendObj = { name: newlayer.options.name, legend: legendInfoData, layer: newlayer };
            htmllegend.addLegend(legendInfoData);
            this.htmlLegendObjects.push(legendObj);
            // htmllegend.addLegend(legendInfoData);
          }
        }
      }
    } else {
      const legendInfoData = this.floodForecastUtils.getLegendData(layers.options.legendData, layers);
      const legendObj = { name: layers.options.name, legend: legendInfoData, layer: layers };
      htmllegend.addLegend(legendInfoData);
      // console.log(htmllegend)
      this.htmlLegendObjects.push(legendObj);
      // htmllegend.addLegend(legendInfoData);
    }
  }

  showThrobberValue() {
    for (const throbber of this.throbbers) {
      if (throbber) { return true; }
    }
    return false;
  }

  routeChange(item) {
    if(this.view != item){
      this.isActive = !this.isActive;
      const moduleName = this.router.url.split('/')[1];
      const stateId = this.router.url.split('/')[3];
      let stateIdDynamic = stateId;
      // console.log(this.router.url.split('/'))
      if(moduleName == 'floodforecast' && item == 'mis'){
        stateIdDynamic="akbm"
      }
      this.router.navigate([moduleName, item, stateIdDynamic]);
    }
  }

}
